import type { AppProps, AppContext } from 'next/app'
// import netStore from '@/store/Net'
import * as Sentry from '@sentry/nextjs'
import '../styles/globals.scss'
import { DioxAddressContextProvider, DioxContextProvider } from 'common/hooks'

const isDev = process.env.NODE_ENV === 'development'

function MyApp({ Component, pageProps }: AppProps) {
  const getLayout =
    (Component as any).getLayout || ((page: JSX.Element) => page)
  return (
    <DioxContextProvider>
      <DioxAddressContextProvider {...pageProps}>
        {getLayout(<Component {...pageProps} />, pageProps)}
      </DioxAddressContextProvider>
    </DioxContextProvider>
  )
}
// only run in server side
MyApp.getInitialProps = async ({ Component, ctx }: AppContext) => {
  let pageProps: { [key: string]: any } = {}
  const cacheAddress = (ctx.req as any)?.cookies?.cacheAddress

  try {
    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }
    if (cacheAddress) {
      pageProps.cacheAddress = JSON.parse(cacheAddress)
    }
    return { pageProps }
  } catch (err) {
    !isDev && Sentry.captureException(err)
    return { ...pageProps }
  }
}

export default MyApp
